import { observable, computed, action } from 'mobx';


class Store {
    @observable sceneName = 'guide';
    @observable sceneStep = '';
    @observable showNurse = false;
    @observable sceneMasker = '';

    // @computed get currSceneBg() {
    //     return scenesBg[this.sceneName] && scenesBg[this.sceneName].src;
    // }
    // @computed get currSceneBgType() {
    //     return scenesBg[this.sceneName] && scenesBg[this.sceneName].type;
    // }
    // @computed get currSceneTip() {
    //     return scenesTip[this.sceneName];
    // }
    // @computed get currMasker() {
    //     return scenesMasker[this.sceneMasker];
    // }
    @action changeScene(sceneName){
        this.sceneStep = sceneName;
        // this.showNurse = scenesNurse.indexOf(sceneName) >= 0;
        let newScene = sceneName != 'nurseStation10' ? sceneName.slice(0, sceneName.length-1) : 'nurseStation';
        if(newScene != this.sceneName){
            this.sceneName = newScene;
            setTimeout(() => {
                // window.onSceneChange();
            }, 0)
        }      
    }
    @action changeMasker(masker){
        this.sceneMasker = masker;
        setTimeout(() => {
            // window.onMaskerChange();
        }, 0)
    }
}
const store = new Store();
export default store;